/**
 * Auth state shared across the application via events.
 *
 * Components subscribe to `authService.onChange()` to react to state transitions.
 * The guest user ID is a well-known sentinel: records with this createdBy are never synced.
 */

export const GUEST_USER_ID = '00000000-0000-4000-a000-000000000000'

export type AuthStatus = 'guest' | 'authenticating' | 'authenticated'

export type PlanTier = 'free' | 'basecamp' | 'alpine'

export interface AuthState {
  status: AuthStatus
  userId: string
  email?: string
  displayName?: string
  givenName?: string
  familyName?: string
  picture?: string
  phoneNumber?: string
  birthdate?: string
  planTier?: PlanTier
  /** ISO date the current paid period ends; absent for free/lifetime. */
  planRenewsAt?: string
  /** Plan after the period ends: same tier (renews), 'free' (ends), or a lower
   *  tier (scheduled downgrade). Absent for free; absent (along with planRenewsAt)
   *  for an unlimited/comp grant — no end date. */
  planNext?: PlanTier
}

export const GUEST_STATE: AuthState = {
  status: 'guest',
  userId: GUEST_USER_ID,
}
